//EXTERNAL
import React from "react";
//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";

// Default select button to add new filter
export function DefaultFilterButton() {
  return (
    <div className="flex" data-testid="icon">
      <ComponentLibrary.PCIconPicker icon="plus" utilityClasses="mr2" />
      <span className="fw4">Add filter</span>
    </div>
  );
}
